import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => {
    // In dark mode the chart canvas is already background.paper, so the widget sits on the dialog/popover
    // surface (#101010) to read as a floating panel. Light mode separates fine with the elevation shadow.
    const surface = theme.palette.mode === 'dark' ? '#101010' : theme.palette.background.paper
    // Same edge as the dialog paper: the default divider (#202020) all but vanishes against the dark chart.
    const edge = theme.palette.mode === 'dark' ? '#444444' : theme.palette.divider    
    return {
        container: {
            position: 'fixed',
            margin: 0,
            borderRadius: '4px',
            padding: 0,
            overflow: 'visible',
            display: "flex",
            backgroundColor: surface,
            border: `1px solid ${edge}`
        },
        resizeContainer: {
            width: '100%',
            height: '100%',
            overflow: 'auto'
        },
        resizeHandle: {
            width: '16px',
            height: '16px',
            position: 'absolute',
            bottom: 0,
            right: 0,
            zIndex: 1,
            
            '&::after': {
                content: '""',
                display: 'block',
                cursor: 'se-resize',
                position: 'absolute',
                width: '100%',
                height: '100%',
                border: "8px solid transparent",
                // borderTopColor: "#bfbfbf", uncomment to show triangular resize handle
                transform: "translate(8px, 8px) rotate(-45deg)",
                
            }
        },
        heading: {
            fontWeight: 500,
            padding:'4px',
            paddingLeft: '8px',
            cursor: "grab",
            borderRadius: '4px 4px 0 0',
            borderBottom: `1px solid ${edge}`,
            position: 'sticky',
            top: 0,
            zIndex: 10
        },
        dragging: {
            cursor: "grabbing"
        },
        hidden: {
            opacity: 0
        },
        content: {
            flexGrow: 1,
            overflow: 'auto',
            maxHeight: '100%',
            backgroundColor: surface
        },
        // Compact take on the app's dialog-title ExtraSmallButton + ClearIcon pair; sized to the 14px header.
        headerButton: {
            minWidth: 24,
            width: 24,
            height: 24,
            padding: 0,
            '& svg': {
                fontSize: 16
            }
        }
    }
})